import { render, staticRenderFns } from "./EnRBandChart.vue?vue&type=template&id=63a466c3&scoped=true"
import script from "./EnRBandChart.vue?vue&type=script&lang=ts"
export * from "./EnRBandChart.vue?vue&type=script&lang=ts"
import style0 from "./EnRBandChart.vue?vue&type=style&index=0&id=63a466c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a466c3",
  null
  
)

export default component.exports